export default __webpack_public_path__ + "static/media/form_error.ae4f9fc9.svg";